import { Common } from "@secondcloset/types";
import { getAPIFromDomain } from "lib/api";

interface UpdateDriverUserParams {
  id: string;
  companyName: string;
  serviceAreas: string[];
  driverType: string;
}

export const updateDriverUser = async ({
  id,
  companyName,
  serviceAreas,
  driverType,
}: UpdateDriverUserParams): Promise<Common.DriverUser> => {
  const api = getAPIFromDomain("accounts");

  const body = {
    fleet_operator: companyName,
    service_areas: serviceAreas,
    driver_type: driverType,
  };
  const response = await api.put(`/driver_users/${id}`, body);
  return response.data;
};
